"use strict";

var _objectSpread = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.G_HELP_DOMAIN = exports.NOTI_DOMAIN = exports.LOGIN_DOMAIN = exports.AFWBBS_DOMAIN = exports.SOTONG_DOMAIN = exports.LOG_API_DOMAIN = exports.ADBALLOON_DOMAIN = exports.ITEMS_DOMAIN = exports.ITEM_DOMAIN = exports.POINT_DOMAIN = exports.NOTE_DOMAIN = exports.VOD_DOMAIN = exports.PLAY_DOMAIN = exports.BJ_AFREECA_DOMAIN = exports.GATEWAY_API_DOMAIN = exports.API_M_DOMAIN = exports.BJ_PROFILE_DOMAIN = exports.STIMG_DOMAIN = exports.RES_DOMAIN = exports.DOMAIN = exports.HOST = void 0;
var domains_1 = require("@afreecatv/domains");
exports.HOST = _objectSpread({}, (0, domains_1.hostGenerator)({
  environment: "development",
  currentProtocol: document.location.protocol,
  hostname: document.location.hostname
}));
exports.DOMAIN = exports.HOST.DOMAIN;
exports.RES_DOMAIN = exports.HOST.RES_AFREECATV;
exports.STIMG_DOMAIN = exports.HOST.STIMG_AFREECATV;
exports.BJ_PROFILE_DOMAIN = exports.HOST.PROFILE_IMG_AFREECATV;
exports.API_M_DOMAIN = exports.HOST.API_M_AFREECATV;
exports.GATEWAY_API_DOMAIN = exports.HOST.AFEVENT_AFREECATV;
exports.BJ_AFREECA_DOMAIN = exports.HOST.BJ_AFREECATV;
exports.PLAY_DOMAIN = exports.HOST.PLAY_AFREECATV;
exports.VOD_DOMAIN = exports.HOST.VOD_AFREECATV;
exports.NOTE_DOMAIN = exports.HOST.NOTE_AFREECATV;
exports.POINT_DOMAIN = exports.HOST.POINT_AFREECATV;
exports.ITEM_DOMAIN = exports.HOST.ITEM_AFREECATV;
exports.ITEMS_DOMAIN = exports.HOST.ITEMS_AFREECATV;
exports.ADBALLOON_DOMAIN = exports.HOST.ADBALLOON_AFREECATV;
exports.LOG_API_DOMAIN = exports.HOST.EVENTAPI_AFREECATV;
exports.SOTONG_DOMAIN = exports.HOST.SOTONG_AFREECATV;
exports.AFWBBS_DOMAIN = exports.HOST.AFWBBS1_AFREECATV;
exports.LOGIN_DOMAIN = exports.HOST.LOGIN_AFREECATV;
exports.NOTI_DOMAIN = exports.HOST.NOTI_AFREECATV;
exports.G_HELP_DOMAIN = exports.HOST.GHELP_AFREECATV;